import React, { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import styles from "./SubNav.module.scss";
import EMPSelectField from "../components/EMPSelectField/EMPSelectField";
import {
  OPT_IN,
  RESERVATION_DEPOSIT,
  TERMS_AND_CONDITIONS,
} from "../../common/Constants";
import { Grid, FormControl, Dialog } from "@mui/material";

const SubNavDropdown = ({ user, onDealerChanged, t }) => {
  const [open, setOpen] = useState(false);
  const brand = user.brand;

  const notFullyOnboardedDealers = user.dealersNotFullyOnboarded
    ? user.dealersNotFullyOnboarded[TERMS_AND_CONDITIONS].concat(
        user.dealersNotFullyOnboarded[RESERVATION_DEPOSIT]
      ).concat(user.dealersNotFullyOnboarded[OPT_IN])
    : [];

  const dealerGroup = user.dealerGroup.filter((dealer) => {
    return dealer.isOnboarded && dealer.commonId.endsWith(brand);
  });

  const updateDealer = (event) => {
    let dealer;
    const selectedValue = event.target.value;
    const showAll = selectedValue === "All";

    if (selectedValue === "DISABLED") {
      setOpen(true);
    } else if (showAll) {
      dealer = user.dealerGroup.find(
        (currentDealer) =>
          currentDealer.dealerType === "HUB" ||
          currentDealer.dealerType === "MDLR"
      );

      onDealerChanged(dealer, true);
    } else {
      dealer = user.dealerGroupingsMap[selectedValue];
      onDealerChanged(dealer);
    }
  };

  const menuItems = [
    {
      text: t("SubNav.all"),
      value: "All",
    },
  ];

  dealerGroup.forEach((dealer) => {
    const dealerText = notFullyOnboardedDealers.includes(
      dealer.completeDealerId
    )
      ? `${String.fromCodePoint(0x26a0)} ${dealer.name} (${dealer.regionalId})`
      : `${dealer.name} (${dealer.regionalId})`;

    menuItems.push({
      value: dealer.isOnboarded ? dealer.commonId : "DISABLED",
      text: dealerText,
    });
  });

  const selectedDealer = user.showAll
    ? "All"
    : user.dealerGroup.find((dealer) => dealer.commonId === user.commonId)
        ?.commonId;

  return (
    <div id="dropdown" className={styles.dropdownDiv}>
      <Grid container>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl id="menu" fullWidth={true}>
            <EMPSelectField
              testId="dealerSelect"
              value={selectedDealer}
              onChange={updateDealer}
              menuItems={menuItems}
            />
          </FormControl>
        </Grid>
      </Grid>

      <Dialog
        open={open}
        close={() => setOpen(false)}
        icon={true}
        title={t("SubNav.disabledDealerTitle")}
        body={t("SubNav.disabledDealerBody")}
      />
    </div>
  );
};

const dealerShape = PropTypes.shape({
  commonId: PropTypes.string.isRequired,
  completeDealerId: PropTypes.string,
  dealerType: PropTypes.string,
  isOnboarded: PropTypes.bool,
  name: PropTypes.string,
  regionalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

SubNavDropdown.propTypes = {
  onDealerChanged: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    commonId: PropTypes.string,
    dealerGroup: PropTypes.arrayOf(dealerShape).isRequired,
    dealerGroupingsMap: PropTypes.objectOf(dealerShape).isRequired,
    dealersNotFullyOnboarded: PropTypes.shape({
      [TERMS_AND_CONDITIONS]: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ),
      [RESERVATION_DEPOSIT]: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ),
      [OPT_IN]: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ),
    }),
    showAll: PropTypes.bool,
  }).isRequired,
};

export default withTranslation("emp")(SubNavDropdown);
